import React from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';

import { useGlobalQueries } from '@/exceed';

import useVideoCompose from '../hooks/useVideoCompose';
import useVideoProperties from '../hooks/useVideoProperties';

import getVideosAdminTabs from '../helpers/getVideosAdminTabs';

import VideosAdminBody from '../components/videosAdminBody';

const VideosAdminBodyContainer = ({ isHomePage = false, isTopicsPage = false, videoVersion }) => {
  const { id, orgId, tabId, type } = useParams();
  const { videoProperties, videoPropertiesKey } = useVideoProperties({
    isEnabled: !isHomePage && !isTopicsPage,
  });
  const { videoCompose } = useVideoCompose({
    isEnabled: ['info', 'enrollments'].some((tab) => tab === tabId),
  });

  const getActiveId = () => tabId || type;

  const getTabsUrlPrefix = () => {
    const rootUrl = `/videos/organizations/${orgId}`;

    if (isHomePage) return rootUrl;

    return isTopicsPage ? `${rootUrl}/${type}/topics/${id}` : `${rootUrl}/${type}/${id}`;
  };

  const tabs = getVideosAdminTabs({
    isHomePage,
    isTopicsPage,
    id,
    type,
    ...useGlobalQueries(),
    videoVersion,
    videoProperties,
    videoPropertiesKey,
    videoCompose,
  });
  const url = getTabsUrlPrefix();
  const activeId = getActiveId();

  return <VideosAdminBody tabs={tabs} url={url} activeId={activeId} />;
};

VideosAdminBodyContainer.propTypes = {
  isHomePage: PropTypes.bool,
  isTopicsPage: PropTypes.bool,
};

export default VideosAdminBodyContainer;
